<template>
  <span v-if="lang === 'de'">
    Ich stimme den <router-link to="/terms-of-services">Nutzungsbedingungen</router-link> zu
  </span>
  <span v-else-if="lang === 'en'">
    I agree to the <router-link to="/terms-of-services">terms of service</router-link>
  </span>
  <span v-else-if="lang === 'ru'">
    Я согласен с условиями <router-link to="/terms-of-services">предоставления услуг</router-link>
  </span>
  <span v-else-if="lang === 'tr'">
    <router-link to="/terms-of-services">Hizmet Koşullarını</router-link> kabul ediyorum
  </span>
  <span v-else>
    <router-link to="/terms-of-services">İstifadəçi qaydalarını</router-link> qəbul edirəm
  </span>
</template>

<script>
export default {
  computed: {
    lang() {
      return this.$store.state.lang;
    }
  }
};
</script>
